export class LoadActiveSportsAction {
  static readonly type = '[Sports] LoadActiveSportsAction';
}


export class FilterSportsByTermsAction {
  static readonly type = '[Sports] FilterSportsByTermsAction';

  constructor(public readonly payload: { term: string }) {
  }
}

export class LoadSportDefinitionAction {
  static readonly type = '[Sports] LoadSportDefinitionAction';

  constructor(public readonly sportId: string) {
  }
}

export class ResetFilterSportDefinitionAction {
  static readonly type = '[Sports] ResetFilterSportDefinitionAction';
}

export class SetBackScreenSportDefinitionAction {
  static readonly type = '[Sports] SetBackScreenSportDefinitionAction';

  constructor(public readonly payload: { backScreen: string }) {
  }
}
